import React from 'react';
import loadable from '@loadable/component';

import useIsBrowser from 'hooks/useIsBrowser';

// The new Consumer app uses a newer version of Nuka Carousel, which uses a
// named export rather than a default export.
const NukaCarouselLib = loadable(() =>
  import('nuka-carousel').then(mod => mod.Carousel)
);

const NukaCarousel = props => {
  const isBrowser = useIsBrowser();

  if (!isBrowser) {
    return null;
  }

  return <NukaCarouselLib {...props} />;
};

export default NukaCarousel;
